import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../Modal/Modal'
import Button from '../Button/Button'
import {
  Content,
  AnimatedWrapper,
  Footer,
  ActionWrapper
} from './styles'
import AnimatedCheckMark from '../AnimatedCheckMark/AnimatedCheckMark'
import AnimatedWarning from '../AnimatedWarning/AnimatedWarning'
import AnimatedXCircle from '../AnimatedXCircle/AnimatedXCircle'
import { HeadingTertiary, Text } from '../../Styles/Typography'
// Success
// Warning
// Danger
// Info

const AnimatedIcon = ({ success, warning, danger }) => {
  let Icon = null
  if (success) {
    Icon = AnimatedCheckMark
  }
  if (warning) {
    Icon = AnimatedWarning
  }
  if (danger) {
    Icon = AnimatedXCircle
  }
  return Icon && <Icon size={80} />
}

const SweetAlert = ({ isOpen, success, warning, danger, title, text, confirmBtnText, showCancel, cancelBtnText, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen} noCloseIcon sm>
      <Content>
        <AnimatedWrapper>
          <AnimatedIcon success={success} warning={warning} danger={danger} />
        </AnimatedWrapper>
        {title && <HeadingTertiary>{title}</HeadingTertiary>}
        {text && <Text>{text}</Text>}
      </Content>
      <Footer>
        {
          showCancel && <ActionWrapper>
            <Button text onClick={onCancel}>
              {cancelBtnText}
            </Button>
          </ActionWrapper>
        }
        <ActionWrapper>
          <Button onClick={onConfirm}>
            {confirmBtnText}
          </Button>
        </ActionWrapper>
      </Footer>
    </Modal>
  )
}

SweetAlert.defaultProps = {
  showCancel: false,
  cancelBtnText: 'Cancel',
  confirmBtnText: 'Confirm'
}

SweetAlert.propTypes = {
  showCancel: PropTypes.bool
}

export default SweetAlert



// WEBPACK FOOTER //
// ./src/Components/SweetAlert/SweetAlert.jsx